// src/hooks/useRegisterUTMs.ts
import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
];

export function useRegisterUTMs() {
  const location = useLocation();
  const posthog = usePostHog();

  useEffect(() => {
    if (!posthog) return; // PostHog not initialized yet

    const searchParams = new URLSearchParams(location.search);
    const utmData: Record<string, string> = {};

    UTM_KEYS.forEach((key) => {
      const value = searchParams.get(key);
      if (value) utmData[`hub_${key}`] = value;
    });

    if (Object.keys(utmData).length > 0) {
      console.log("utm", utmData);
      // Register UTM params as session attributes only once
      posthog.register_once(utmData);
      // Also Register UTM params as user attributes only once
      posthog.setPersonProperties(undefined, utmData);
    }
  }, [location.search, posthog]);
}
